var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.789 8.16299C23.4572 5.82974 20.3561 4.54341 17.0525 4.54199C10.2425 4.54199 4.70195 10.0797 4.70054 16.8868C4.6977 19.0529 5.26579 21.1822 6.34812 23.0592L4.5957 29.4569L11.1435 27.7399C12.9555 28.7259 14.9841 29.243 17.0468 29.243H17.0525C23.8595 29.243 29.4001 23.7038 29.403 16.8967C29.4044 13.5987 28.1209 10.4977 25.789 8.16299Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5511 19.2099L19.1263 18.6389C19.6547 18.1148 20.4906 18.0482 21.0997 18.476C21.6891 18.8897 22.2217 19.2609 22.7176 19.6065C23.5052 20.1534 23.6001 21.2754 22.9216 21.9525L22.413 22.4611",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5387 11.5871L12.0473 11.0785C12.7244 10.4013 13.8464 10.4962 14.3933 11.2825C14.7375 11.7783 15.1087 12.311 15.5238 12.9003C15.9516 13.5095 15.8864 14.3453 15.3609 14.8737L14.7899 15.4489",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.413 22.4619C20.315 24.55 16.7889 22.7764 14.0051 19.9912",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.008 19.9948C11.2242 17.2097 9.45056 13.685 11.5387 11.5869",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7899 15.4492C15.2418 16.1618 15.8213 16.8673 16.4758 17.5218L16.4786 17.5246C17.1331 18.1791 17.8386 18.7586 18.5512 19.2105",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.270031c2ff77b6797798c9018a4c7552.svg";
export { ForwardRef as ReactComponent };